import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { finalProjectStatusTypes } from "../../../enums/finalProjectStatusTypes";
import { formatDate } from "../../../../shared/utils/utils";
import Scroll from "../../../../shared/components/ui/scroll/Scroll";
import FinalProjectCard from "./finalProjectCard/FinalProjectCard";
import classes from "./FinalProjectCards.module.css";

const FinalProjectCards = ({ isSubmitted, presentationDate, submissionBox }) => {
    const { texts } = useSelector(s => s.translate);
    const scrollRef = useRef(null);
    const [focus, setFocus] = useState(null);
    const [cards, setCards] = useState({ card2: null, card3: null, card4: null });
    const cardsMode = isSubmitted ? "submitted" : submissionBox.isOpen ? "openNotSubmitted" : "boxClosed"

    useEffect(() => {
        switch (cardsMode) {
            case "boxClosed":
                setFocus(2);
                setCards({ card2: { type: finalProjectStatusTypes.processing, text: texts.processing } });
                break;

            case "openNotSubmitted":
                setFocus(3);
                setCards({
                    card3:
                    {
                        type: finalProjectStatusTypes.processing,
                        text: !submissionBox.isClosed ? texts.systemOpenForSubmission : texts.systemClosed
                    }
                });
                break;

            case "submitted":
                setFocus(4);
                setCards({
                    card2: { type: finalProjectStatusTypes.approved, text: texts.finish },
                    card3: { type: finalProjectStatusTypes.approved, text: texts.workSubmitted },
                    card4: presentationDate
                        ? {
                            type: finalProjectStatusTypes.approved,
                            text: texts.invitationExists,
                            date: presentationDate
                        }
                        : {
                            type: finalProjectStatusTypes.processing,
                            text: texts.invitationNotReceived
                        }
                });
                break;
        }
    }, [cardsMode, presentationDate, texts]);

    useEffect(() => {
        if (!focus || window.innerWidth > 600) return;
        const focusedCard = scrollRef.current?.querySelector('[data-focused-card="true"]');
        focusedCard?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    }, [focus]);

    return (
        <div className={classes.SumissionStepsContainer} style={{ width: presentationDate ? 790 : 1075 }}>
            <div className={classes.SumissionStepsTitle}>{texts.submissionSteps}</div>
            <Scroll ref={scrollRef} showDots={true} dropClass={classes.CardsScroll} downDropStyle={classes.CardsTrack}>
                <div className={classes.SumissionStepsContent}>
                    <FinalProjectCard
                        className={classes.firstCard}
                        text={texts.finalApproval}
                        type={finalProjectStatusTypes.approved}
                        statusText={texts.approved}
                    />

                    <FinalProjectCard
                        className={classes.secondCard}
                        text={texts.WritingWorkChapters}
                        isFocused={focus === 2}
                        type={cards.card2?.type}
                        statusText={cards.card2?.text}
                    />

                    <FinalProjectCard
                        className={classes.thirdCard}
                        text={texts.submissionForEvaluation}
                        isFocused={focus === 3}
                        date={
                            <div>
                                {submissionBox.startDate && <div>{texts.fromDate} {formatDate(submissionBox.startDate)}</div>}
                                {submissionBox.deadline && <div>{texts.untilDate} {formatDate(submissionBox.deadline)}</div>}
                            </div>
                        }
                        type={cards.card3?.type}
                        statusText={cards.card3?.text}
                    />

                    <FinalProjectCard
                        className={classes.fourthCard}
                        text={texts.faceToFaceExam}
                        isFocused={focus === 4}
                        type={cards.card4?.type}
                        statusText={cards.card4?.text}
                        statusDate={cards.card4?.date}
                    />
                </div>
            </Scroll>
        </div>
    );
};

export default FinalProjectCards;
